import React from 'react';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  NamedLink,
} from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ExplainPaymentPage.module.css';
import image from '../../assets/trailer-with-sticker.avif';

const ExplainPaymentPage = () => {
  return (
    <StaticPage
      title="Paying for hires explained"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ExplainPaymentPage',
        description: 'Paying for hires explained',
        name: 'Paying for hires explained',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.contentWrapper}>
            <div className={css.imageContainer}>
              <img src={image} alt="trailer" className={css.croppedImage} />
            </div>
            <div className={css.contentMain}>
              <h1 className={css.helpTitle}>
                The payment process when hiring through Local Trailer Hire
              </h1>
              <p>You've made a booking request – congratulations! So, what happens next?</p>
              <h2>A temporary hold is placed on your card</h2>
              <p>
                As soon as you place your booking request we put a temporary hold charge on your
                card to ensure the funds are available. This should show up in your online banking
                as a "pending" transaction.
              </p>
              <h2>When the trailer owner confirms, the charge is confirmed</h2>
              <p>
                If the trailer owner confirms the booking, the payment will be marked as completed.
                After your bank's processing time, the transaction will no longer be "pending" in
                your online banking.
              </p>
              <p>
                We will hold the funds until 24 hours after your scheduled pick-up, and then pay the
                funds out to the trailer owner. This gives both the trailer owner and you time to
                make sure everything is as expected, and contact us in the event of any issues.
              </p>
              <h2>If the trailer owner does not confirm, the charge is cancelled</h2>
              <p>
                If the trailer declines your booking request (or the booking request expires, or you
                cancel it), the temporary hold ("pending" transaction) will be cancelled by us
                immediately. It will then disappear from your online banking. The removal of the
                "pending" charge can take a few minutes to several hours depending on your bank's
                processing times.
              </p>
            </div>
            <NamedLink name="HelpPage" className={css.link}>
              <h3 className={css.heading}>
                {'<'} <FormattedMessage id="Footer.toHelpPage" />
              </h3>
            </NamedLink>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default ExplainPaymentPage;
